import { generateBreadcrumbs } from '@/utilities/router/generate-breadcrumbs';
import { generateHeader } from '@/utilities/router/generate-header';

import sidebarItems from './sidebar';

import type { RouteRecordRaw } from '@bv/router';

const cloudLinesBreadcrumbs = generateBreadcrumbs({
  label: 'Cloud lines',
  route: { name: 'cl' },
});

const cloudLinesRoutes: RouteRecordRaw = {
  name: 'cl',
  path: 'cloud-lines',
  meta: {
    sidebar: sidebarItems,
    header: generateHeader('Cloud lines'),
  },
  redirect: { name: 'cl-providers-list' },
  children: [
    {
      path: 'providers',
      meta: {
        breadcrumbs: cloudLinesBreadcrumbs({
          label: 'Providers',
          route: { name: 'cl-providers-list' },
        }),
        redirectUnauthorized: { name: 'cl-providers-list' },
      },
      children: [
        {
          path: '',
          name: 'cl-providers-list',
          meta: {
            permissions: 'read-providers',
          },
          component: () => import('@/views/Main/CloudLines/Providers/ProvidersList.vue'),
        },
        {
          path: '',
          component: () => import('@/views/Main/CloudLines/Providers/ProviderForm.vue'),
          children: [
            {
              name: 'cl-add-provider',
              path: 'add',
              meta: {
                permissions: 'write-providers',
              },
            },
            {
              name: 'cl-edit-provider',
              path: 'edit/:id',
              meta: {
                permissions: 'update-providers',
              },
            },
          ] as RouteRecordRaw[],
        },
        {
          name: 'cl-provider-details',
          path: ':id',
          meta: {
            permissions: 'read-providers',
          },
          component: () => import('@/views/Main/CloudLines/Providers/ProviderDetails.vue'),
        },
      ],
    },
    {
      path: 'numbers',
      meta: {
        breadcrumbs: cloudLinesBreadcrumbs({
          label: 'Numbers',
          route: { name: 'cl-numbers-list' },
        }),
        redirectUnauthorized: { name: 'cl-numbers-list' },
      },
      children: [
        {
          path: '',
          name: 'cl-numbers-list',
          meta: {
            permissions: 'read-numbers',
          },
          component: () => import('@/views/Main/CloudLines/Numbers/NumbersList.vue'),
        },
        {
          path: 'upload',
          name: 'cl-upload-numbers',
          meta: {
            permissions: 'write-numbers',
          },
          component: () => import('@/views/Main/CloudLines/Numbers/BulkUpload/UploadNumbers.vue'),
        },
        {
          path: ':id',
          name: 'cl-number-details',
          meta: {
            permissions: 'read-numbers',
          },
          component: () => import('@/views/Main/CloudLines/Numbers/NumberDetails.vue'),
        },
      ],
    },
    {
      name: 'cl-details-report',
      path: 'details-report',
      meta: {
        breadcrumbs: cloudLinesBreadcrumbs({
          label: 'Details report',
          route: { name: 'cl-details-report' },
        }),
        permissions: 'read-cdrs',
      },
      component: () => import('@/views/Main/CloudLines/CallDetailsReport/CallDetailsReport.vue'),
    },
    {
      name: 'cl-authentications',
      path: 'authentications',
      meta: {
        breadcrumbs: cloudLinesBreadcrumbs({
          label: 'Authentications',
          route: { name: 'cl-authentications' },
        }),
        permissions: 'read-credentials',
      },
      component: () => import('@/views/Main/CloudLines/Authentications/AuthenticationsList.vue'),
    },
    {
      name: 'cl-servers',
      path: 'servers',
      meta: {
        breadcrumbs: cloudLinesBreadcrumbs({
          label: 'Servers',
          route: { name: 'cl-servers' },
        }),
        permissions: 'cloud-lines-read-servers',
      },
      component: () => import('@/views/Main/CloudLines/servers/ServersList.vue'),
    },
  ],
};

export default cloudLinesRoutes;
